import { createNamespacedHelpers } from 'vuex'
import * as API from 'src/api/dev/icon'
import * as T from './types'

const {
    mapState,
    mapActions,
    mapGetters,
    mapMutations
} = createNamespacedHelpers('icon')

const module = {
    namespaced: true,

    state: {
        icons: [],
        // 构建中，成功，失败
        status: '',
        hasChange: false,
        iconTotal: 0,
        groups: [],
    },

    getters: {
        isBuilding(state) {
            return state.status === T.STATUS.IS_BUILDING
        }
    },

    mutations: {
        [T.SET_GROUP_LIST](state, payload) {
            const { items } = payload
            state.groups = items
        },
        [T.SET_ICON_LIST](state, payload) {
            const { items, total, needBuildIcon } = payload
            state.icons = items
            state.iconTotal = total
            state.hasChange = !!needBuildIcon
        },
        [T.SET_BUILD_STATUS](state, payload) {
            state.status = payload
        },
        [T.SET_ICON_STATUS](state, payload) {
            const { needBuildIcon } = payload
            state.hasChange = !!needBuildIcon
        }
    },

    actions: {
        [T.GET_GROUP_LIST]({ commit }, payload) {
            return API.getGroupList(payload)
                .then(res => {
                    commit(T.SET_GROUP_LIST, res)
                    return res
                })
        },
        [T.CREATE_GROUP](store, payload) {
            return API.createGroup(payload)
        },
        [T.EDIT_GROUP](store, payload) {
            return API.editGroup(payload)
        },
        [T.DELETE_GROUP](store, payload) {
            return API.deleteGroup(payload)
        },

        [T.GET_ICON_LIST]({ commit }, payload) {
            return API.getIconList(payload)
                .then(res => {
                    commit(T.SET_ICON_LIST, res)
                    return res
                })
        },
        [T.DELETE_ICON](store, payload) {
            return API.deleteIcon(payload)
        },

        [T.UPLOAD_ICON_LIST](store, payload) {
            return API.uploadIcons(payload)
        },

        [T.BUILD_ICON](store, payload) {
            return API.buildIcon(payload)
        },
        [T.GET_BUILD_STATUS]({ commit }, payload) {
            return API.getBuildStatus(payload)
                .then(res => {
                    commit(T.SET_BUILD_STATUS, res)
                    return res
                })
        },

        [T.GET_ICON_STATUS]({ commit }, payload) {
            const params = {
                ...payload,
                page: 1,
                pageSize: 10
            }
            return API.getIconList(params)
                .then(res => {
                    commit(T.SET_ICON_STATUS, res)
                    return res
                })
        }
    },
}

export {
    mapState,
    mapActions,
    mapGetters,
    mapMutations
}

export default module
